import { Numeric9PlusCircleOutlineIcon } from './Numeric9PlusCircleOutlineIcon';

/**
 * author: Contributors
 * id 00BD21E8-FAF1-470D-8F64-0030C1C222F3
 * name numeric-9-plus-circle-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-9-plus-circle-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const NumericNinePlusCircleOutlineIcon = Numeric9PlusCircleOutlineIcon;
export default NumericNinePlusCircleOutlineIcon